
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { QrCode } from 'lucide-react';

interface QrCodePaymentProps {
  qrCodeUrl: string;
  amount: number;
  serviceName: string;
  showCard?: boolean;
  className?: string;
}

export function QrCodePayment({ qrCodeUrl, amount, serviceName, showCard = true, className }: QrCodePaymentProps) {
  const [showQrDialog, setShowQrDialog] = useState(false);

  const qrContent = (
    <div className={`flex flex-col items-center ${className || ''}`}>
      <div className="bg-white p-3 border rounded-lg shadow-sm">
        {/* Display the Stripe-generated QR code image */}
        <img src={qrCodeUrl} alt="Payment QR Code" className="w-48 h-48" />
      </div>
      <div className="mt-4 text-center">
        <p className="font-medium text-lg">${amount.toFixed(2)}</p>
        <p className="text-sm text-muted-foreground">{serviceName}</p>
        <p className="text-xs text-muted-foreground mt-2">
          Scan to complete your payment for this appointment
        </p>
      </div>
    </div>
  );

  if (!showCard) {
    return (
      <>
        <Button 
          variant="outline" 
          onClick={() => setShowQrDialog(true)}
          className="flex items-center"
        >
          <QrCode className="mr-2 h-4 w-4" />
          View QR Code
        </Button>
        
        <Dialog open={showQrDialog} onOpenChange={setShowQrDialog}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Payment QR Code</DialogTitle>
            </DialogHeader>
            {qrContent}
          </DialogContent>
        </Dialog>
      </>
    );
  }

  return (
    <Card className="mt-6">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">In-Person Payment</CardTitle>
      </CardHeader>
      <CardContent>
        {qrContent}
      </CardContent>
    </Card>
  );
}
